import React from 'react';
import ReactDom from 'react-dom';
import BookingForm from '../components/BookingForm.jsx';

function isInViewport(selector) {
    if ($(selector).length === 0) {
        return false;
    }

    var el = $(selector);
    var topOfEl = el.offset().top;
    var botOfEl = el.offset().top + el.outerHeight();
    var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
    var topOfScreen = $(window).scrollTop();

    if ((bottomOfScreen > topOfEl) && (topOfScreen < botOfEl)){
        return true;
    } else {
        return false;
    }
}

export default {
    init() {
        const bookingForm = document.getElementById('booking-form');
        const {allow_booking_date, disabled_dates} = bookingForm.dataset;
        ReactDom.render(<BookingForm allowBookingDate={allow_booking_date} disabledDates={JSON.parse(disabled_dates)} />, bookingForm);
    },
    finalize() {
        // $('.fabe-input select').customSelect();

        $('[data-toggle="modal"] .custom-select__option').prop('disabled', false);

        // $('[data-toggle="datepicker"]').datepicker();

        $(window).scroll(function() {
            if (isInViewport('.booking-form__total.text-right')) {
                $('.booking-form__sticky-total').addClass('slideDown');
            } else {
                $('.booking-form__sticky-total').removeClass('slideDown');
            }
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-booking.jsx